import SecureLS from "secure-ls";
import Dexie from "dexie";
import helpers from "../functions/helpers";

const ls = new SecureLS({
    encodingType: 'aes',
    encryptionSecret: '😎🇧🇮💲﹩ⓣ🇹R🔴💲'
});

const db = new Dexie('QuipuuDB', { autoOpen: true });

db.version(1).stores({
    clients: 'id,full_name,identification,phone',
    providers: 'id,full_name,factory,phone,email,phone_prefix,text',
    products: 'id,name,category,image,sale_price,active,barcode,get_product_variants,not_for_sale,get_other_product_variants,price_from,get_additions',
    ingredients: 'id,name,is_active',
});

const localDB = {
    initialData(data){
        let user = {
            id: data.user.id,
            full_name: data.user.full_name,
            avatar: data.user.avatar,
            email: data.user.email,
            rol: data.user.type,
            store: data.user.store_id,
            branch_office: data.user.branch_office,
        };

        ls.set('token', data.token);
        ls.set('branch_office', data.user.branch_office);
        ls.set('user', user);
        ls.set('menu', data.user.menu);
        ls.set('plan_access', data.user.plan_access);
        ls.set('features', data.user.features);
        ls.set('rol_access', data.user.rol_access);
        ls.set('store', data.user.store_data);
        ls.set('store_settings', data.user.store_settings);
        ls.set('categories', data.user.categories);
        ls.set('change_logs', data.user.change_logs);
        ls.set('store_security', data.user.store_security);
    },
    cleanSession() {
        localStorage.clear();
        db.delete();
    },
    getAuthToken(){
        try{
            return ls.get('token');
        }catch (e) {
            this.cleanSession();
            return null;
        }
    },
    sessionToken: function () {
        return " JWT " + ls.get('token');
    },
    getUser(){
        return ls.get('user');
    },
    check_feature(key){
        let features = ls.get('features');
        return features.includes(key);
    },
    get(key){
        try {
            return ls.get(key);
        }catch (e) {
            return null;
        }
    },
    set(key, data){
        return ls.set(key, data);
    },
    remove(key){
        return ls.remove(key);
    },
    checkRolAccess(access){
        let rol_access = ls.get('rol_access');
        return rol_access.some(item => item === access);
    },
    checkPlanAccessExclude(access){
        try {
            let plan_access = ls.get('plan_access');
            return plan_access.access_exclude.some(item => item === access);
        }catch (e) {
            return true;
        }
    },
    saveSaleStorage(data, navigation) {
        this.set('sale', helpers.jsonify(data));
        this.set('navigation', navigation);
    },
    addOrUpdateList(key, data){
        let values = this.get(key);
        if(values){
            if (values.some(value => value.id === data.id)){
                values = values.map(value => {
                    return data.id === value.id ? data:value;
                });
            }else{
                values = values.concat(data)
            }
            this.set(key, values);
        }else{
            values = [];
            this.set(key, values.concat(data))
        }
    },
    removeItemList(key, id){
        let values = this.get(key);
        let data = values.filter(value => {
            return value.id !== id;
        });
        this.set(key, data);
    },
    async updateList(key, data){
        await this.openDB();
        await db[key].bulkPut(data);
    },
    async addList(key, data){
        await this.openDB();
        await db[key].clear();
        await db[key].bulkAdd(data);
    },
    updateDB(key, data){
        db[key].update(data.id, data);
    },
    addDB(key, data){
        db[key].add(data);
    },
    addOrUpdateDB(key, data){
        try{
            this.getDB(key).then(values => {
                if (values.some(res => res.id === data.id)){
                    this.updateDB(key, data);
                }else{
                    this.addDB(key, data);
                }
            })
        }catch (_){}
    },
    async deleteDB(key, id){
        await this.openDB();
        await db[key].where('id').equals(id).delete();
    },
    async getDB(key) {
        await this.openDB();
        return await db[key].toArray();
    },
    findProviders(search) {
        return db['providers'].orderBy('text').filter((provider) => helpers.slugify(provider.text).match(helpers.slugify(search)) || provider.id===search).limit(10).toArray();
    },
    findClients(search) {
        return db['clients'].orderBy('full_name').filter((client) => helpers.slugify(client.full_name).match(helpers.slugify(search)) || helpers.slugify(client.identification).match(helpers.slugify(search)) || client.id===search).limit(10).toArray();
    },
    findProducts(search, category) {
        return db['products'].orderBy('name').filter((product) =>{
            if(category && product.barcode){
                return  (helpers.slugify(product.name).match(helpers.slugify(search)) || (helpers.slugify(product.barcode).match(helpers.slugify(search)))) && product.active === true && product.not_for_sale === false && product.category === category && !product.variant_parent;
            }
            else if(category && !product.barcode){
                return  helpers.slugify(product.name).match(helpers.slugify(search)) && product.active === true && product.not_for_sale === false && product.category === category && !product.variant_parent;
            }
            else if(product.barcode){
                return  (helpers.slugify(product.name).match(helpers.slugify(search)) || (helpers.slugify(product.barcode).match(helpers.slugify(search)))) && product.active === true && product.not_for_sale === false && !product.variant_parent;
            }
            else{
                return  helpers.slugify(product.name).match(helpers.slugify(search)) && product.active === true && product.not_for_sale === false  && !product.variant_parent;
            }
        }).limit(20).toArray();
    },
    findProduct(id) {
        return db['products'].filter((product) =>{
            return  product.id === id;
        }).first();
    },
    async findShoppingList(search) {
        let data = []
        let products = await db['products'].orderBy('name').filter((product) =>{
            return  helpers.slugify(product.name).match(helpers.slugify(search)) && product.active === true;
        }).limit(10).toArray();
        let ingredients = await db['ingredients'].orderBy('name').filter((ingredient) =>{
            return  helpers.slugify(ingredient.name).match(helpers.slugify(search)) && ingredient.is_active === true;
        }).limit(10).toArray();
        products.forEach(product =>  data.push({id: product.id, name: product.name}));
        ingredients.forEach(ingredient =>  data.push({id: ingredient.id, name: ingredient.name}));
        return data.sort((a,b) => a.name > b.name ? 1:a.name < b.name ? -1:0);
    },
    async keyExist(key){
        await this.openDB();
        if(!!db[key]){
            return await db[key].count() > 0;
        }else{
            return false;
        }
    },
    async openDB(){
        if(!db.isOpen()){
            await db.open();
        }
    }
};

export default localDB;



// WEBPACK FOOTER //
// ./src/data/localDB.js